import React, { useRef, useState, useEffect } from 'react';
import { Send, Users, Bell } from 'lucide-react';
import api from '../api';



const iconMap = { main: Send, updates: Bell, buy: Users, channel: Send };
const colorMap = {
  main: { bg: 'rgba(0,240,255,0.1)', border: 'rgba(0,240,255,0.2)', icon: '#00F0FF' },
  updates: { bg: 'rgba(255,215,0,0.1)', border: 'rgba(255,215,0,0.2)', icon: '#FFD700' },
  buy: { bg: 'rgba(74,222,128,0.1)', border: 'rgba(74,222,128,0.2)', icon: '#4ADE80' },
  channel: { bg: 'rgba(0,240,255,0.1)', border: 'rgba(0,240,255,0.2)', icon: '#00F0FF' },
};

function FadeIn({ children, delay = 0, className = '' }) {
  const ref = useRef(null);
  const [v, setV] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setV(true); }, { threshold: 0.05 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <div ref={ref} className={`transition-all duration-700 ${className}`}
    style={{ opacity: v?1:0, transform: v?'translateY(0)':'translateY(30px)', transitionDelay: `${delay}ms` }}>{children}</div>;
}

export default function TelegramSection() {
  const [channels, setChannels] = useState([]);

  useEffect(() => {
    api.get(`/api/telegram-channels`).then(r => setChannels(r.data)).catch(() => {});
  }, []);

  if (channels.length === 0) return null;

  return (
    <section id="telegram" data-testid="telegram-section" className="py-20 sm:py-28 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#2AABEE]/[0.03] to-transparent" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <FadeIn className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 text-xs font-bold uppercase tracking-[0.25em] text-[#2AABEE] border border-[#2AABEE]/30 rounded-full mb-4 bg-[#2AABEE]/5">
            Telegram
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-2">
            Join Our Telegram Channels
          </h2>
          <p className="font-hindi text-neonGold/70 text-lg">हमारे Telegram चैनल से जुड़ें</p>
        </FadeIn>

        <div className={`grid gap-6 ${channels.length >= 3 ? 'sm:grid-cols-3' : channels.length === 2 ? 'sm:grid-cols-2 max-w-3xl mx-auto' : 'max-w-md mx-auto'}`}>
          {channels.map((ch, i) => {
            const colors = colorMap[ch.channel_type] || colorMap.channel;
            const Icon = iconMap[ch.channel_type] || Send;
            return (
              <FadeIn key={ch.url + i} delay={i * 120}>
                <a href={ch.url} target="_blank" rel="noopener noreferrer"
                  data-testid={`telegram-card-${i}`}
                  className="glass-card rounded-xl p-8 text-center group cursor-pointer block h-full">
                  <div className="w-14 h-14 mx-auto mb-4 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: colors.bg, border: `1px solid ${colors.border}` }}>
                    <Icon className="w-6 h-6" style={{ color: colors.icon }} />
                  </div>
                  <h3 className="font-heading text-xl font-bold text-white mb-1">{ch.name}</h3>
                  <p className="text-gray-400 text-sm mb-1">{ch.description}</p>
                  {ch.hindi_text && <p className="font-hindi text-gray-500 text-xs mb-4">{ch.hindi_text}</p>}
                  <span className="inline-flex items-center gap-1.5 bg-[#2AABEE]/10 text-[#2AABEE] font-semibold text-xs px-4 py-2 rounded-full border border-[#2AABEE]/20 group-hover:bg-[#2AABEE] group-hover:text-white transition-all">
                    <Send size={12} /> Open in Telegram
                  </span>
                </a>
              </FadeIn>
            );
          })}
        </div>
      </div>
    </section>
  );
}
